import React from 'react';
import {
  Box,
  DialogActions,
  DialogContent,
  Typography,
  styled,
} from '@mui/material';
import CbButton from '../../../../../../../components/Buttons/CbButton';
import { Show } from '../../../../../../../components/Show';
import type { Languages } from '../../../../../../../i18n/i18n.language-config';
import { deriveCurrencyFormat } from '../../../../../../../i18n/currencies';
import type UnderwriterSupplementalInfo from '../shared/UnderwriterSupplementalInfo';

const AppliedRulesAndFactorsModal = ({
  data,
  close,
}: AppliedRulesAndFactorsModalProps) => {
  return (
    <>
      <DialogContent style={{ padding: '2rem 4rem', maxHeight: '25rem' }}>
        <Show when={Boolean(data.appliedRules?.length)}>
          <Typography>Applied Guidelines</Typography>
          <Box component="ul" pl="1.25rem" mt="0.25rem">
            {data.appliedRules?.map((rule) => (
              <StyledBox component="li" key={rule}>
                {rule}
              </StyledBox>
            ))}
          </Box>
        </Show>

        <Show when={Boolean(data.lostCost)}>
          <Typography>Lost Cost</Typography>
          <Box component="ul" pl="1.25rem" mt="0.25rem">
            <StyledBox component="li">
              Lost Cost: {deriveCurrencyFormat(data.language, data.lostCost)}
            </StyledBox>
          </Box>
        </Show>

        <Show when={Boolean(data.factors?.length)}>
          <Typography>Rating Factors</Typography>
          <Box component="ul" pl="1.25rem" mt="0.25rem">
            {data.factors?.map((factor) => (
              <StyledBox component="li" key={factor.id}>
                {factor.name}: {factor.calculatedFactor}
              </StyledBox>
            ))}
          </Box>
        </Show>
      </DialogContent>
      <DialogActions>
        <CbButton styleName="ctaButton" onClick={close}>
          Okay
        </CbButton>
      </DialogActions>
    </>
  );
};

export const AppliedRulesAndFactorsModalConfig = {
  PxDeclineQuoteModal: {
    component: AppliedRulesAndFactorsModal,
    config: {
      title: 'Applied Guidelines and Factors',
      fullWidth: true,
      maxWidth: 'sm',
    },
  },
};

type AppliedRulesAndFactorsModalProps = {
  data: React.ComponentProps<typeof UnderwriterSupplementalInfo> & {
    language: Languages;
  };
  close: () => void;
};

const StyledBox = styled(Box)(({ theme }) => {
  return {
    transition: 'all 0.2s',
    padding: '0.1rem',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.background.active,
      color: theme.palette.primary.cowbellBlue,
    },
  };
});
